export const prepareOptionsList = ({
  models,
  loadCount,
  onClick,
  activeModelIds = [],
  customClasses
}) => {
  const modelsCount = models.length;
  return models.slice(0, loadCount || modelsCount).map((model, itemIx) => {
    const isFirst = !itemIx;
    const isLast = models.length - 1 === itemIx;
    const isActive = activeModelIds.indexOf(model.id) > -1;
    const props = {
      isFirst,
      isLast,
      isActive,
      model
    };
    if (customClasses) {
      props.customClasses = customClasses;
    }
    if (onClick) {
      props.onClick = onClick;
    }

    return props;
  });
};
